export const isLinkToStateSymbol = Symbol('isLinkToState');

export function isLinkTo(linkTo) {
  return linkTo?.[isLinkToStateSymbol];
}
